import places from './places';

export default {
  places,
};
